import { Protocol } from '../Protocol';

export class TestItemProtocol {
  public static readonly ALL_TEST_ITEM: string = `${Protocol.YATUNG_API_ROOT}/expt/item/all`;
  public static readonly TEST_ITEM: string = `${Protocol.YATUNG_API_ROOT}/expt/item`;
  public static readonly TEST_ITEM_BY_TEST_ORDER: string = `${Protocol.YATUNG_API_ROOT}/expt/item/all/expt`;
  public static readonly TEST_ITEM_BY_DEMAND_ORDER: string = `${Protocol.YATUNG_API_ROOT}/expt/item/all/req`;
}
